import React from 'react';

const GlowingOrb = ({ size = 'md', color = 'red', className = '' }) => {
  const sizes = {
    xs: 'w-1.5 h-1.5',
    sm: 'w-2 h-2',
    md: 'w-2.5 h-2.5',
    lg: 'w-3 h-3',
    xl: 'w-4 h-4'
  };

  const colors = {
    red: 'bg-pebble-red',
    primary: 'bg-primary-500',
    grey: 'bg-grey-400',
    white: 'bg-white'
  };

  return (
    <div 
      className={`${sizes[size]} ${colors[color]} rounded-full animate-ai-breathe animate-ai-glow ${className}`}
    />
  );
};

export default GlowingOrb;
